import styled from 'styled-components';
import { ZIndex } from '@optimus-web/core';
import { TooltippedSpan } from './TooltippedSpan';

export const AlignedTooltipedSpan = styled(TooltippedSpan)`
    display: inline-flex;
    vertical-align: middle;
    ${(props) => (props.onClick ? `cursor: pointer;` : ``)};
    z-index: ${ZIndex.Highest};
`;
